export default __webpack_public_path__ + "static/media/bunny.d24dd4aa.svg";